import { Component } from '@angular/core';
import { BrandingService } from './core/services/branding.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Simulador-Rentas-Vitalicias';

  constructor(private brandingService: BrandingService) {
    this.brandingService.initialize();
  }
}
